export default "__VITE_ASSET__8f248f4d__"